import { useState } from 'react';
import { Button, Typography, TextField, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { forgetPassword } from '../../../API/password';

const loginSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required')
});

const ForgotPage = () => {
    const [isLoading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: ''
        },
        validationSchema: loginSchema,
        onSubmit: (values) => {
            console.log('hiiiiiiiii', values.email);
            forgetPassword(values, toast);
            console.log('forget passss');
        }
    });

    return (
        <Box
            display="flex"
            justifyContent="c
            enter"
            alignItems="center"
            flexDirection="column"
            width="50%"
            color="primary"
        >
            <Box>
                <Typography
                    component="h2"
                    variant="h2"
                    className="auth-heading"
                >
                    Forgot Password
                </Typography>
                <Box mt={4}>
                    <form onSubmit={formik.handleSubmit}>
                        <Box mb={2}>
                            <Typography variant="body">Email</Typography>
                            <TextField
                                name="email"
                                variant="outlined"
                                size="small"
                                fullWidth
                                color="secondary"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.email &&
                                    Boolean(formik.errors.email)
                                }
                                helperText={
                                    formik.touched.email && formik.errors.email
                                }
                                placeholder="enter your registered email"
                            />
                        </Box>

                        <Box textAlign="end" mt={2}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                // onClick={handleSubmit}
                            >
                                {isLoading && (
                                    <CircularProgress
                                        size={20}
                                        sx={{
                                            marginRight: '6px',
                                            color: '#ffff'
                                        }}
                                    />
                                )}
                                SUBMIT
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Box>
            <ToastContainer />
        </Box>
    );
};
// Login.propTypes = {
//     dispatch: PropTypes.func.isRequired
// };

export default ForgotPage;
